"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Team = void 0;
/**
 *  @swagger
 *  components:
 *    schemas:
 *
 *      Team:
 *        type: object
 *        enum:
 *          - RED
 *          - BLUE
 *          - NEUTRAL
 *          - ASSASSIN
 */
var Team;
(function (Team) {
    Team["RED"] = "red";
    Team["BLUE"] = "blue";
    Team["NEUTRAL"] = "neutral";
    Team["ASSASSIN"] = "assassin";
})(Team = exports.Team || (exports.Team = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90ZWFtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7Ozs7Ozs7Ozs7R0FZRztBQUNILElBQVksSUFLWDtBQUxELFdBQVksSUFBSTtJQUNkLG1CQUFXLENBQUE7SUFDWCxxQkFBYSxDQUFBO0lBQ2IsMkJBQW1CLENBQUE7SUFDbkIsNkJBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUxXLElBQUksR0FBSixZQUFJLEtBQUosWUFBSSxRQUtmIn0=